module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/811908f316459621f7ac069558a4200a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_forward.svg
// module id = FP8j
// module chunks = 0